import React, { useState, useEffect } from 'react';
import UnionHeaderNav from '@xo-union/tk-component-header-nav/remote';
import MembershipService from '@xo-union/sdk-membership';
import OnboardingMembershipModal from './OnboardingMembershipModal';

interface Props {
  product: string | undefined;
}

const redirectUri = process.env.REACT_APP_DASHBOARD_REDIRECT || '/';
const client = new MembershipService();
const redirect = () => window.location.assign(redirectUri);
const handleLogout = () => client.logOut().then(redirect);

const HeaderNav = ({ product }: Props) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [openModal, setOpenModal] = useState<string | null>(null);

  useEffect(() => {
    // solution to remove the no-op, but it indicates a memory leak error
    let _isMounted = true;
    const checkLoggedIn = async () => {
      try {
        const member = await client.getMember();
        if (_isMounted) setLoggedIn(!!member);
      } catch (error) {
        // no logging here as this is the unauthorized path which will render the logged out version
      }
    };

    checkLoggedIn();

    return () => {
      _isMounted = false;
    };
  }, []);

  const createAccount = () => {
    setLoggedIn(true);
  };

  return (
    <>
      <UnionHeaderNav
        activeProduct="wedding-website"
        data-testid="tk-header"
        loggedIn={loggedIn}
        analyticsProps={{ product }}
        metadata={{ applicationName: product }}
        onClickLogOut={handleLogout}
        onClickSignUp={() => setOpenModal('SIGN_UP')}
        onClickLogIn={() => setOpenModal('LOG_IN')}
      />
      <OnboardingMembershipModal
        onAccountCreated={createAccount}
        currentModal={openModal}
        onClose={() => setOpenModal(null)}
      />
    </>
  );
};

export default HeaderNav;
